var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-data-reupload',{attrs:{"is-loading":_vm.isLoading,"display-success":_vm.displaySuccess},on:{"toggle-snackbar":function($event){_vm.displaySuccess = $event},"reupload":_vm.onReupload}})
}
var staticRenderFns = []

export { render, staticRenderFns }